var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcSendMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 16,
    viewBox: "0 0 19 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0724 1H4.26159C2.82863 1 1.66699 2.21316 1.66699 3.70967V12.2903C1.66699 13.7868 2.82863 15 4.26159 15H15.0724C16.5054 15 17.667 13.7868 17.667 12.2903V3.70967C17.667 2.21316 16.5054 1 15.0724 1Z",
    stroke: "#4F5662",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.66699 4.38708L8.94483 7.87895C9.17136 7.98765 9.4177 8.04392 9.66699 8.04392C9.91628 8.04392 10.1626 7.98765 10.3892 7.87895L17.667 4.38708",
    stroke: "#4F5662",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSendMail);
export default __webpack_public_path__ + "static/media/ic-send-mail.3913b0de8a737c062dc5a83918257ede.svg";
export { ForwardRef as ReactComponent };